import { render, staticRenderFns } from "./AddCity.vue?vue&type=template&id=b9ffa08c"
import script from "./AddCity.vue?vue&type=script&lang=js"
export * from "./AddCity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports